import React from "react";
import { Route } from "react-router-dom";
import Terms from "../components/index";

const TermsRoutes = () => {
  return (
    <>
      <Route path="/terms-condition" element={<Terms />} /> 
    </>
  );
};

export default TermsRoutes;
